module.exports = __webpack_public_path__ + "static/media/fracture-set.90ed4ccd.png";